const getters = {
  token: (state) => state.usuarios.token,
  usuario: (state) => state.usuarios.usuario,
  isAuthenticated: (state) => !!state.usuarios.token,
  hasModulos: (state) => state.usuarios.modulos.length,
  userRoles: (state) => state.usuarios.usuario?.roles
};
export default getters;
